import React from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const FeaturedTemplates = ({ templates, onPreview, onUse }) => {
  return (
    <div className="bg-gradient-to-br from-primary/5 to-accent/5 rounded-lg border border-border p-4 md:p-6">
      <div className="flex items-center justify-between mb-4 md:mb-6">
        <div>
          <h2 className="text-xl md:text-2xl font-semibold text-foreground mb-1">
            Featured Templates
          </h2>
          <p className="text-sm md:text-base text-muted-foreground">
            Hand-picked premium designs for your next project
          </p>
        </div>
        <Icon name="Sparkles" size={24} className="text-accent flex-shrink-0" />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
        {templates?.map((template) => (
          <div
            key={template?.id}
            className="bg-card rounded-lg border border-border overflow-hidden hover:shadow-xl transition-all duration-300 group"
          >
            <div className="relative aspect-[4/3] overflow-hidden bg-muted">
              <Image
                src={template?.thumbnail}
                alt={template?.thumbnailAlt}
                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background via-background/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end justify-center pb-4 gap-2">
                <Button
                  variant="secondary"
                  size="sm"
                  iconName="Eye"
                  iconPosition="left"
                  onClick={() => onPreview(template)}
                >
                  Preview
                </Button>
                <Button
                  variant="default"
                  size="sm"
                  iconName="Plus"
                  iconPosition="left"
                  onClick={() => onUse(template)}
                >
                  Use
                </Button>
              </div>
              <div className="absolute top-3 left-3 bg-accent text-accent-foreground px-2 py-1 rounded text-xs font-medium flex items-center gap-1">
                <Icon name="Crown" size={12} />
                Featured
              </div>
            </div>

            <div className="p-4">
              <h3 className="font-semibold text-base md:text-lg text-foreground mb-2 line-clamp-1">
                {template?.name}
              </h3>
              <p className="text-sm text-muted-foreground line-clamp-2 mb-3">
                {template?.description}
              </p>
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-1 text-warning">
                  <Icon name="Star" size={14} className="fill-current" />
                  <span className="text-xs font-medium">{template?.rating}</span>
                </div>
                <span className="text-xs text-muted-foreground">
                  {template?.downloads} downloads
                </span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FeaturedTemplates;